import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { supabase } from "../config/supabaseClient";

// Async thunk to save training category budget configuration
export const saveTrainingCategoryBudgetConfiguration = createAsyncThunk(
  "trainingCategoryBudget/saveTrainingCategoryBudgetConfiguration",
  async ({ budgetData, yearId, companyId, total_budget }, { rejectWithValue }) => {
    try {
      
      // Transform the budget data to match the required format
      const trainingCategoryBudgetConfig = budgetData.map(item => ({
        trainingType: item.trainingType,
        percentage: parseFloat(item.percentage) || 0,
        budget: parseFloat(item.budget) || 0,
        headCount: {
          male: parseInt(item.headCount?.male) || 0,
          female: parseInt(item.headCount?.female) || 0
        }
      }));

      const { data: responseData, error } = await supabase
        .from("configurations")
        .update({ training_category_budget_config: trainingCategoryBudgetConfig, total_budget: total_budget})
        .eq("company_id", companyId)
        .eq("year_id", yearId)
        .select();
      
      if (error) {
        console.error("Save training category budget error:", error);
        throw error;
      }
      return responseData;
    } catch (err) {
      console.error("Save training category budget catch error:", err);
      return rejectWithValue(err.message);
    }
  }
);

// Async thunk to fetch training category budget configuration
export const fetchTrainingCategoryBudgetConfiguration = createAsyncThunk(
  "trainingCategoryBudget/fetchTrainingCategoryBudgetConfiguration",
  async ({ yearId, companyId }, { rejectWithValue }) => {
    try {
      const { data, error } = await supabase
        .from("configurations")
        .select("training_category_budget_config")
        .eq("company_id", companyId)
        .eq("year_id", yearId)
        .maybeSingle();
      
      if (error) {
        console.error("Fetch training category budget error:", error);
        throw error;
      }
      return data?.training_category_budget_config || [];
    } catch (err) {
      console.error("Fetch training category budget catch error:", err);
      return rejectWithValue(err.message);
    }
  }
);

const trainingCategoryBudgetSlice = createSlice({
  name: "trainingCategoryBudget",
  initialState: {
    budgetConfiguration: [],
    loading: false,
    error: null,
  },
  reducers: {
    clearError: (state) => {
      state.error = null;
    },
    clearBudgetConfiguration: (state) => {
      state.budgetConfiguration = [];
    },
    updateBudgetConfiguration: (state, action) => {
      state.budgetConfiguration = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      // Save Training Category Budget Configuration cases
      .addCase(saveTrainingCategoryBudgetConfiguration.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(saveTrainingCategoryBudgetConfiguration.fulfilled, (state, action) => {
        state.loading = false;
        // Update the budget configuration with the saved data
        if (action.payload && action.payload[0]?.training_category_budget_config) {
          state.budgetConfiguration = action.payload[0].training_category_budget_config;
        }
      })
      .addCase(saveTrainingCategoryBudgetConfiguration.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      // Fetch Training Category Budget Configuration cases
      .addCase(fetchTrainingCategoryBudgetConfiguration.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchTrainingCategoryBudgetConfiguration.fulfilled, (state, action) => {
        state.loading = false;
        state.budgetConfiguration = action.payload;
      })
      .addCase(fetchTrainingCategoryBudgetConfiguration.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { clearError, clearBudgetConfiguration, updateBudgetConfiguration } = trainingCategoryBudgetSlice.actions;
export default trainingCategoryBudgetSlice.reducer; 